// Create a responsive slider hook for the homepage brand logo
// Specific ID #shopify-section-1633873596011ae20f
// Created by KL, 2021-10-29

$(document).ready(function(){

  var winWidth = $(window).width();

  if((winWidth > 730)){            

    $('#shopify-section-1633873596011ae20f .logo-bar').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:"<div class='home-brand-logo-slider-arrow left'><button class='slideshow__arrow slideshow__arrow-left' aria-label='Previous slide'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-left' viewBox='0 0 7 11'><path d='M5.5.037a1.5 1.5 0 0 1 1.06 2.56l-2.94 2.94 2.94 2.94a1.5 1.5 0 0 1-2.12 2.12l-4-4a1.5 1.5 0 0 1 0-2.12l4-4A1.5 1.5 0 0 1 5.5.037z' fill='#fff' class='layer'></path></svg></button></div>",
      nextArrow:"<div class='home-brand-logo-slider-arrow right'><button class='slideshow__arrow slideshow__arrow-right' aria-label='Next slide'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-right' viewBox='0 0 7 11'><path d='M1.5 11A1.5 1.5 0 0 1 .44 8.44L3.38 5.5.44 2.56A1.5 1.5 0 0 1 2.56.44l4 4a1.5 1.5 0 0 1 0 2.12l-4 4A1.5 1.5 0 0 1 1.5 11z' fill='#fff'></path></svg></button></div>",
      dots: false,
    });

  }else{
    $(' #shopify-section-1633873596011ae20f .logo-bar').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:"<div class='home-brand-logo-slider-arrow left'><button class='slideshow__arrow slideshow__arrow-left' aria-label='Previous slide'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-left' viewBox='0 0 7 11'><path d='M5.5.037a1.5 1.5 0 0 1 1.06 2.56l-2.94 2.94 2.94 2.94a1.5 1.5 0 0 1-2.12 2.12l-4-4a1.5 1.5 0 0 1 0-2.12l4-4A1.5 1.5 0 0 1 5.5.037z' fill='#fff' class='layer'></path></svg></button></div>",
      nextArrow:"<div class='home-brand-logo-slider-arrow right'><button class='slideshow__arrow slideshow__arrow-right' aria-label='Next slide'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-right' viewBox='0 0 7 11'><path d='M1.5 11A1.5 1.5 0 0 1 .44 8.44L3.38 5.5.44 2.56A1.5 1.5 0 0 1 2.56.44l4 4a1.5 1.5 0 0 1 0 2.12l-4 4A1.5 1.5 0 0 1 1.5 11z' fill='#fff'></path></svg></button></div>",
      dots: false,
    });
  }
  
});
